/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from "react";
import axios from "axios";
import "../styles/PhotoGallery.css";

// Import fallback images from local folder
import SAVE1 from "../assets/images/SAVE1.jpg";
import SAVE2 from "../assets/images/SAVE2.jpg";
import SAVE3 from "../assets/images/SAVE3.jpg";
import SAVE4 from "../assets/images/SAVE4.jpg";
import SAVE5 from "../assets/images/SAVE5.jpg";
import SAVE6 from "../assets/images/SAVE6.jpg";
import SAVE7 from "../assets/images/SAVE7.jpg";
import SAVE8 from "../assets/images/SAVE8.jpg";
import SAVE9 from "../assets/images/SAVE9.jpg";
import SAVE10 from "../assets/images/SAVE10.jpg";
import SAVE11 from "../assets/images/SAVE11.jpg";
import SAVE12 from "../assets/images/SAVE12.jpg";
import SAVE13 from "../assets/images/SAVE13.jpg";
import SAVE14 from "../assets/images/SAVE14.jpg";
import SAVE15 from "../assets/images/SAVE15.jpg";
import SAVE16 from "../assets/images/SAVE16.jpg";
import SAVE17 from "../assets/images/SAVE17.jpg";
import SAVE18 from "../assets/images/SAVE18.jpg";
import SAVE19 from "../assets/images/SAVE19.jpg";
import SAVE20 from "../assets/images/SAVE20.jpg";


const API_BASE = "https://kingdomhomesapi.onrender.com/api/gallery";
// const API_BASE = "http://localhost:5002/api/gallery";

const FALLBACK_IMAGES = [SAVE1,SAVE2,SAVE3,SAVE4,SAVE5,SAVE6,SAVE7,SAVE8,SAVE9,SAVE10,SAVE11,SAVE12,SAVE13,SAVE14,SAVE15,SAVE16,SAVE17,SAVE18,SAVE19,SAVE20];

const PhotoGallery = () => {
  const [photos, setPhotos] = useState([]);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const res = await axios.get(API_BASE);
        const data = Array.isArray(res.data) ? res.data : [];
        const sorted = data.sort((a, b) => (a.index || 0) - (b.index || 0));

        // if no images found, use local fallbacks
        if (sorted.length === 0) {
          const fallback = FALLBACK_IMAGES.map((url, i) => ({
            id: `image-${i}`,
            url,
          }));
          setPhotos(fallback);
        } else {
          setPhotos(sorted);
        }
      } catch (err) {
        console.error("Error fetching images:", err);
        // Load fallback on API failure
        const fallback = FALLBACK_IMAGES.map((url, i) => ({
          id: `image-${i}`,
          url,
        }));
        setPhotos(fallback);
      }
    };

    fetchImages();
  }, []);

  const handleImageError = (e) => {
    e.target.src = SAVE1; // a single default fallback if one image fails
  };

  return (
    <section className="photo-gallery">
      <h2 className="gallery-title">Photo Gallery</h2>
      <p className="gallery-subtitle">
        A glimpse of our latest work, projects, and moments captured.
      </p>

      <div className="gallery-grid">
        {photos.length > 0 ? (
          photos.map((photo, index) => (
            <div key={photo.id || index} className="gallery-card">
              <img
                src={photo.url}
                alt={`Gallery Image ${index + 1}`}
                loading="lazy"
                onError={handleImageError}
              />
            </div>
          ))
        ) : (
          <p>No images found</p>
        )}
      </div>
    </section>
  );
};

export default PhotoGallery;
